import React from "react"
import { Box, FileText, Fish, Package, Plus, Scale, Users } from "lucide-react"
import { NavItemBase } from "./NavItemBase.jsx"

/**
 * @param {{ route: string, notImplemented?: boolean }} props
 */
export function Orders({ route, notImplemented }) {
    return <NavItemBase label="Orders" Icon={FileText} route={route} notImplemented={notImplemented} />
}

/**
 * @param {{ route: string, notImplemented?: boolean }} props
 */
export function Manifests({ route, notImplemented }) {
    return <NavItemBase label="Manifests" Icon={Package} route={route} notImplemented={notImplemented} />
}

/**
 * @param {{ route: string, notImplemented?: boolean }} props
 */
export function WeighIn({ route, notImplemented }) {
    return <NavItemBase label="Weigh In" Icon={Scale} route={route} notImplemented={notImplemented} dimmed />
}

/**
 * @param {{ route: string, notImplemented?: boolean }} props
 */
export function BoxUp({ route, notImplemented }) {
    return <NavItemBase label="Box Up" Icon={Box} route={route} notImplemented={notImplemented} dimmed />
}

/**
 * @param {{ route: string, notImplemented?: boolean }} props
 */
export function Customers({ route, notImplemented }) {
    return <NavItemBase label="Customers" Icon={Users} route={route} notImplemented={notImplemented} />
}

/**
 * @param {{ route: string, notImplemented?: boolean }} props
 */
export function NewOrderForm({ route, notImplemented }) {
    return <NavItemBase label="New Order Form" Icon={Plus} route={route} notImplemented={notImplemented} />
}

/**
 * @param {{ route: string, notImplemented?: boolean }} props
 */
export function FishRoom({ route, notImplemented }) {
    return <NavItemBase label="Fish Room" Icon={Fish} route={route} notImplemented={notImplemented} />
}

